import { roles } from '@transfeeradev/api-enums';

export const getValidAppRoles = () => {
  return Object.values(roles.appRoles).filter(role => role?.name && role?.value);
};
